export const getLineChartOptions = (xAxisData, yAxisData) => ({
  chart: {
    type: "line",
    toolbar: {
      show: false,
    },
    fontFamily: "Ubuntu",
    zoom: {
      enabled: false,
    },
    animations: {
      enabled: true,
      easing: "easeinout",
      speed: 800,
      animateGradually: {
        enabled: true,
        delay: 150,
      },
      dynamicAnimation: {
        enabled: true,
        speed: 350,
      },
    },
  },
  stroke: {
    curve: "smooth",
    width: 2,
  },
  tooltip: {
    enabled: false,
  },
  xaxis: {
    type: "numeric",
    axisTicks: {
      show: true,
      borderType: "solid",
      color: "#edf3f8",
      width: 10,
      offsetX: 0,
      offsetY: 0,
    },
    min: xAxisData.min,
    max: xAxisData.max,
    tickAmount: xAxisData.tickAmount,
    overwriteCategories: Array.from(
      { length: xAxisData.categoriesLength },
      (v, i) => `Renewal ${i}`
    ),
    labels: {
      rotate: -40,
      rotateAlways: xAxisData.rotateLabels,
      show: true,
      style: {
        colors: "#1a344b",
        fontSize: "13px",
        fontFamily: "Ubuntu Mono, sans-serif",
        fontWeight: 400,
      },
    },
    axisBorder: {
      show: false,
    },
  },

  yaxis: [
    {
      axisTicks: {
        show: true,
        borderType: "solid",
        color: "#edf3f8",
        width: 10,
        offsetX: 0,
        offsetY: 0,
      },
      labels: {
        formatter: function (value) {
          return "$" + value;
        },
        align: "right",
        minWidth: 0,
        style: {
          colors: [],
          fontSize: "13px",
          fontFamily: "Ubuntu Mono, sans-serif",
        },
        offsetX: 0,
        offsetY: 0,
        rotate: 0,
      },
      stepSize: Math.ceil(Number(yAxisData.max)) / 5,
      min: yAxisData.min,
      max: Math.ceil(Number(yAxisData.max)),
    },
    {
      opposite: true,
      labels: {
        formatter: function (value) {
          return "";
        },
      },
      axisTicks: {
        show: true,
        borderType: "solid",
        color: "#edf3f8",
        width: 50,
        offsetX: 0,
        offsetY: 0,
      },
      stepSize: Math.ceil(Number(yAxisData.max)) / 5,
      min: yAxisData.min,
      max: Math.ceil(Number(yAxisData.max)),
    },
  ],
  grid: {
    show: true,
    borderColor: "#edf3f8",
    position: "back",
    yaxis: {
      lines: {
        show: true,
      },
    },
    xaxis: {
      lines: {
        show: true,
      },
    },
    padding: {
      top: 10,
      right: 10,
      bottom: 10,
      left: 10,
    },
  },
  legend: {
    show: true,
    showForNullSeries: true,
    showForZeroSeries: true,
    position: "bottom",
    horizontalAlign: "left",
    floating: false,
    fontSize: "13px",
    fontFamily: "Ubuntu Mono, sans-serif",
    fontWeight: 400,
    customLegendItems: [],
    offsetX: -35,
    offsetY: 0,
    labels: {
      colors: ["#97adc6", "#97adc6"],
      useSeriesColors: false,
    },
    markers: {
      width: 18,
      height: 18,
      strokeWidth: 0,
      strokeColor: "#fff",
      fillColors: undefined,
      radius: 2,
      offsetX: -10,
      offsetY: 4,
    },
    itemMargin: {
      horizontal: 30,
      vertical: 0,
    },
    onItemClick: {
      toggleDataSeries: false,
    },
  },
});

export const getLineChartSeries = (renewalData, acquisitionData) => [
  {
    name: "Renewal",
    data: renewalData,
    color: "#0ab7ac",
    zIndex: 2,
  },

  {
    name: "User acquisition cost",
    data: acquisitionData,
    color: "#ffb9f8",
  },
];

export const initRenewalData = [
  0.3, 1.1, 1.05, 2.5, 2.4, 3.2, 3.1, 3.9, 3.9, 3.9, 3.9, 3.8, 4.5, 4.5, 4.5,
  4.5, 4.5, 4.5,
];

export const initAcquisitionData = Array(18).fill(2.8);

export const xAxisInitData = {
  min: 1,
  max: 16,
  categoriesLength: 5,
  tickAmount: 4,
  rotateLabels: false,
};

export const yAxisInitData = {
  min: 0,
  max: 5,
};
